import { InitialDataLoaderContext } from 'pages/MainLayout/InitialDataLoaderContext'
import { useContext } from 'react'

export const useRefetchKYC = () => {
  const { refetchData } = useContext(InitialDataLoaderContext)

  return refetchData
}
